import { firstValueFrom } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../env/env.service';
import { NavigationEnd } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private globalService = inject(GlobalService);
  private http = inject(HttpClient);
  private envService = inject(EnvironmentService);

  public sendEvent = (action: string, category = 'general', label = 'Click', eventValue = 0) => {
    //
  };

  public handleRouterEvent = (event: NavigationEnd, prevEvent?: NavigationEnd) => {
    if (this.globalService.isServer()) return;
    const params = event && this.globalService.getParameters(event.urlAfterRedirects);
    const prevParams = prevEvent && this.globalService.getParameters(prevEvent.urlAfterRedirects);

    // we entered a new content page
    if (params && params.mode === 'view') {
      // we come from a content page, check slug
      if (!prevParams || (prevParams && prevParams.slug !== params.slug)) {
        // console.log('[Analytics]', 'Editor Impression', params.slug);
        this.sendImpression('editor', params.slug);
      }
    }
  };

  private sendImpression = async (mode: string, slug: string) => {
    try {
      const res = await firstValueFrom(
        this.http.post<any>(`${this.envService.MetricApi}add`, {
          slug: slug,
          type: 'impressions',
          context: {
            mode: mode,
          },
        }),
      );

      return res;
    } catch (error) {
      //
    }
  };
}
